































































































































































































































































import { defineComponent, reactive, toRefs, onMounted, computed, onBeforeUnmount, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
// @ts-ignore
import VueDragResize from "vue-drag-resize";
import { BModal } from 'bootstrap-vue';
import { UploadItem, ImageItem, SearchCondition, Student, rotateHoseiPosition, DirectionEnum } from "../../modules/teacher/WebupDetail";
import { SplitterComponent, PanesDirective, PaneDirective } from "@syncfusion/ej2-vue-layouts"

export interface Data {
  webup_history_id: string | null
  filter: string | null
  uploadItems: UploadItem[] | null
  imageItems: ImageItem[]
  selectedUploadItem: UploadItem | null
  selectedImageItem: ImageItem | null
  scale: number
  rotates: number[]
  currentPage: number
  perPage: number
  condition: SearchCondition
  students: Student[]
  totalCount: number
  fields: any[]
  errors: string[]
  circleSize: number,
  imagePadding: number
  DirectionEnum: Readonly<{Left: number; Right: number;}>
  sheetTypeName: string
}

// @ts-ignore
export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
    "vue-drag-resize": VueDragResize,
    "ejs-splitter" : SplitterComponent,
    "e-panes": PanesDirective,
    "e-pane": PaneDirective,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/
    const modalSearchStudent = ref<InstanceType<typeof BModal>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      webup_history_id: null,
      filter: "",
      uploadItems: null,
      imageItems: new Array<ImageItem>(),
      selectedUploadItem: null,
      selectedImageItem: null,
      scale: 0.5,
      rotates: [0, 90, 180, 270],
      currentPage: 1,
      perPage: 10,
      condition: new SearchCondition(),
      students: new Array<Student>(),
      totalCount: 0,
      fields: [
        {key: "student_code", label: "生徒CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "email", label: "Email", sortable: true, class: 'text-center b-table-th-td'},
        {key: "course_name", label: "コース", sortable: true, class: 'text-center b-table-th-td'},
        {key: "campus_name", label: "キャンパス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "class_name", label: "クラス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "grade", label: "学年", sortable: true, class: 'text-center b-table-th-td'},
        {key: "kumi", label: "組", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_no", label: "出席番号", sortable: true, class: 'text-center b-table-th-td'},
        {key: "status", label: "在校状態", sortable: true, class: 'text-center b-table-th-td'},
      ],
      errors: [],
      circleSize: 40,
      imagePadding: 30,
      DirectionEnum: DirectionEnum,
      sheetTypeName: null,
    });

    /************************************************************
     * 円形の補正マークの中心座標
     ************************************************************/

    const circleCenter = computed((): number => {
      return state.circleSize / 2;
    });

    /************************************************************
     * 補正マークのCSSスタイル
     ************************************************************/

    const tdStyle = computed((): {[key: string] : string} => {
      let style: any = {};
      style["width"] = `${circleCenter.value}px`;
      style["height"] = `${circleCenter.value}px`;
      return style;
    });

    /************************************************************
     * 補正マークのドラッグ終了イベント
     ************************************************************/

    const dragStop = (idx: number, rect: any) => {
      state.selectedUploadItem.hosei_positions[idx][0] = Math.round(rect.left + circleCenter.value) / state.scale;
      state.selectedUploadItem.hosei_positions[idx][1] = Math.round(rect.top + circleCenter.value) / state.scale;
    }

    /************************************************************
     * エラー有無を返却
     ************************************************************/

    const isExistsError = computed(() => {
      return state.uploadItems.filter(x => x.errors.length > 0).length > 0;
    });

    /************************************************************
     * 絞り込み条件で絞った一覧
     ************************************************************/

    const filteredUploadItems = computed(() => {
      if(state.filter == "1"){
        return state.uploadItems.filter(x => x.errors.length > 0);
      }else if(state.filter == "0"){
        return state.uploadItems.filter(x => x.errors.length == 0);
      }else{
        return state.uploadItems;
      }
    });

    /************************************************************
     * エラーレコードの件数
     ************************************************************/

    const errorCount = computed(() => {
      return state.uploadItems.filter(x => x.errors.length > 0).length;
    });

    /************************************************************
     * 画面サイズに合わせてレイアウト整形
     ************************************************************/
    
    const adjustHeight = () => {
      const winH = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      const imageArea = document.getElementById("image-area");
      const mainArea = document.getElementById("main-area");

      mainArea.style.height = (winH - mainArea.offsetTop) + "px";

      if(tableArea != null){
        tableArea.style.height = (winH - 230) + "px";
      }

      if(imageArea != null){
        imageArea.style.height = (winH - mainArea.offsetTop) + "px";
      }
    };

    /************************************************************
     * 画面表示エリアのCSSスタイル
     ************************************************************/

    const imageStyle = computed((): object => {
      let style: any = {};
      
      if(state.selectedUploadItem != null){
        style["width"] = `${state.selectedUploadItem.width * state.scale}px`;
        style["height"] = `${state.selectedUploadItem.height * state.scale}px`;
        style["transform"] = `rotate(${state.selectedUploadItem.angle}deg)`;
        
        // 回転の中心軸設定
        let translateX: string = "";
        let translateY: string = "";
        if(state.selectedUploadItem.angle == 90){
          translateX = `${state.selectedUploadItem.height * state.scale / 2}px`;
          translateY = `${state.selectedUploadItem.height * state.scale / 2}px`;
        }else if(state.selectedUploadItem.angle == 180){
          translateX = `${state.selectedUploadItem.width * state.scale / 2}px`;
          translateY = `${state.selectedUploadItem.height * state.scale / 2}px`;
        }else if(state.selectedUploadItem.angle == 270){
          translateX = `${state.selectedUploadItem.width * state.scale / 2}px`;
          translateY = `${state.selectedUploadItem.width * state.scale / 2}px`;
        }
        style["transform-origin"]  = `${translateX} ${translateY}`;
      }
      
      return style;
    });

    /************************************************************
     * imgの親divのCSSスタイル
     ************************************************************/
    
    const imageWrapStyle = computed((): object => {
      let style: any = {};
      if(state.selectedUploadItem != null){
        if(state.selectedUploadItem.angle == 0 || state.selectedUploadItem.angle == 180){
          style["height"] = `${(state.selectedUploadItem.height * state.scale) + 30}px`;
        }else{
          style["height"] = `${(state.selectedUploadItem.width * state.scale) + 30}px`;
        }
      }
      return style;
    });

    /************************************************************
     * 拡大ボタン押下
     ************************************************************/
    
    const scaleUp = () => {
      state.scale += 0.05;
    };

    /************************************************************
     * 縮小ボタン押下
     ************************************************************/
    
    const scaleDown = () => {
      if(state.scale > 0.1){
        state.scale -= 0.05;
      }
    };

    /************************************************************
     * 画像を表示エリアの横幅に合わせる
     ************************************************************/
    
    const adjustWidth = () => {
      const elem = document.getElementById("image-area");
      if(elem != null){
        const imageAreaW = elem.clientWidth;
        const imageAreaH = elem.clientHeight;
        const imageW = state.selectedUploadItem.angle == 90 || state.selectedUploadItem.angle == 270 ? state.selectedUploadItem.height : state.selectedUploadItem.width;
        const imageH = state.selectedUploadItem.angle == 90 || state.selectedUploadItem.angle == 270 ? state.selectedUploadItem.width : state.selectedUploadItem.height;
        
        const scaleW = (imageAreaW - (state.imagePadding * 2))/ imageW;
        const scaleH = (imageAreaH - (state.imagePadding * 2))/ imageH;
        state.scale = scaleW > scaleH ? scaleH : scaleW;
      }
    };

    /************************************************************
     * 前へボタン押下
     ************************************************************/
    
    const prevCurrent = () => {
      const idx = state.uploadItems.indexOf(state.selectedUploadItem);
      if(idx > 0){
        changeCurrent(state.uploadItems[idx - 1]);
      }
    };

    /************************************************************
     * 次へボタン押下
     ************************************************************/
    
    const nextCurrent = () => {
      const idx = state.uploadItems.indexOf(state.selectedUploadItem);
      if(state.uploadItems.length > idx + 1){
        changeCurrent(state.uploadItems[idx + 1]);
      }
    };

    /************************************************************
     * 左回転ボタン押下
     ************************************************************/
    
    const rotateLeft = () => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.selectedUploadItem.angle);
      if(rotateIdx == 0){
        angle = 270;
      }else{
        angle = state.selectedUploadItem.angle - 90;
      }
      state.selectedUploadItem.angle = angle;

      if(state.selectedUploadItem.is_use_hosei){
        state.selectedUploadItem.hosei_positions = rotateHoseiPosition(state.selectedUploadItem.hosei_positions, DirectionEnum.Left, state.selectedUploadItem.angle, state.selectedUploadItem.width, state.selectedUploadItem.height);
      }
    };

    /************************************************************
     * 右回転ボタン押下
     ************************************************************/
    
    const rotateRight = () => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.selectedUploadItem.angle);
      if(rotateIdx == 3){
        angle = 0;
      }else{
        angle = state.selectedUploadItem.angle + 90;
      }
      state.selectedUploadItem.angle = angle;

      if(state.selectedUploadItem.is_use_hosei){
        state.selectedUploadItem.hosei_positions = rotateHoseiPosition(state.selectedUploadItem.hosei_positions, DirectionEnum.Right, state.selectedUploadItem.angle, state.selectedUploadItem.width, state.selectedUploadItem.height);
      }
    };

    /************************************************************
     * 一括回転
     ************************************************************/
    
    const rotateAll = async (direction: number) => {

      if(!window.confirm(`一括回転を実行します。よろしいですか？`)){
        return;
      }

      state.uploadItems.forEach(x => {
        let angle = 0;
        if(direction == DirectionEnum.Right){
          const rotateIdx = state.rotates.indexOf(x.angle);
          if(rotateIdx == 3){
            angle = 0;
          }else{
            angle = x.angle + 90;
          }
          x.angle = angle;

          if(x.is_use_hosei){
            x.hosei_positions = rotateHoseiPosition(x.hosei_positions, DirectionEnum.Right, x.angle, x.width, x.height);
          }
        }else{
          const rotateIdx = state.rotates.indexOf(x.angle);
          if(rotateIdx == 0){
            angle = 270;
          }else{
            angle = x.angle - 90;
          }
          x.angle = angle;

          if(x.is_use_hosei){
            x.hosei_positions = rotateHoseiPosition(x.hosei_positions, DirectionEnum.Left, x.angle, x.width, x.height);
          }
        }
      });
    };

    /************************************************************
     * 補正位置名取得
     ************************************************************/

    const getPosName = (idx: number) => {
      var posName = "";
      if(idx == 0){
        posName = "左上";
      }else if(idx == 1){
        posName = "左下";
      }else if (idx == 2){
        posName = "右下";
      }else{
        posName = "右上";
      }
      return posName;
    };

    /************************************************************
     * 補正処理
     ************************************************************/

    const perspectiveTransform = async () => {

      if(!window.confirm(`補正処理を実行します。よろしいですか？`)){
        return;
      }

      state.errors = []
      context.root.$store.dispatch("showOverlay");

      const param: any = {}
      param["base_sheet_id"] = state.selectedUploadItem.base_sheet_id;
      param["webup_history_id"] = state.webup_history_id;
      param["file_name"] = state.selectedUploadItem.file_name;
      param["hosei_positions"] = state.selectedUploadItem.hosei_positions;
      param["angle"] = state.selectedUploadItem.angle;
      param["page"] = state.selectedUploadItem.page_no;

      await http.post(`/api/teacher/webup_detail/perspective_transform`, param).then(response => {
        state.selectedUploadItem.width = response.data.read_result_hash.width;
        state.selectedUploadItem.height = response.data.read_result_hash.height;
        let hosei_positions: number[][] = response.data.read_result_hash.hosei_positions;

        if(state.selectedUploadItem.angle == 90){
          [90].forEach((angle: number) => hosei_positions = rotateHoseiPosition(hosei_positions, DirectionEnum.Right, angle, state.selectedUploadItem.width, state.selectedUploadItem.height));
        }else if(state.selectedUploadItem.angle == 180){
          [90, 180].forEach((angle: number) => hosei_positions = rotateHoseiPosition(hosei_positions, DirectionEnum.Right, angle, state.selectedUploadItem.width, state.selectedUploadItem.height));
        }else if(state.selectedUploadItem.angle == 270){
          [90, 180, 270].forEach((angle: number) => hosei_positions = rotateHoseiPosition(hosei_positions, DirectionEnum.Right, angle, state.selectedUploadItem.width, state.selectedUploadItem.height));
        }

        state.selectedUploadItem.hosei_positions = hosei_positions;
        state.selectedImageItem.base64Image = response.data.base64_image;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 補正リセット
     ************************************************************/

    const resetTransform = async () => {
      if(!window.confirm(`補正をリセットします。よろしいですか？`)){
        return;
      }

      state.errors = []
      context.root.$store.dispatch("showOverlay");

      const param: any = {}
      param["base_sheet_id"] = state.selectedUploadItem.base_sheet_id;
      param["webup_history_id"] = state.webup_history_id;
      param["file_name"] = state.selectedUploadItem.file_name;

      await http.post(`/api/teacher/webup_detail/reset_transform`, param).then(response => {
        state.selectedUploadItem.width = response.data.read_result_hash.width;
        state.selectedUploadItem.height = response.data.read_result_hash.height;
        
        let hosei_positions: number[][] = response.data.read_result_hash.hosei_positions;
        if(state.selectedUploadItem.angle == 90){
          [90].forEach((angle: number) => hosei_positions = rotateHoseiPosition(hosei_positions, DirectionEnum.Right, angle, state.selectedUploadItem.width, state.selectedUploadItem.height));
        }else if(state.selectedUploadItem.angle == 180){
          [90, 180].forEach((angle: number) => hosei_positions = rotateHoseiPosition(hosei_positions, DirectionEnum.Right, angle, state.selectedUploadItem.width, state.selectedUploadItem.height));
        }else if(state.selectedUploadItem.angle == 270){
          [90, 180, 270].forEach((angle: number) => hosei_positions = rotateHoseiPosition(hosei_positions, DirectionEnum.Right, angle, state.selectedUploadItem.width, state.selectedUploadItem.height));
        }

        state.selectedUploadItem.hosei_positions = hosei_positions;
        state.selectedImageItem.base64Image = response.data.base64_image;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 選択中の画像情報変更
     ************************************************************/

    const changeCurrent = async (uploadItem: UploadItem) => {
      
      state.selectedUploadItem = uploadItem;
      const selectedImageItem = state.imageItems.filter(x => x.fileName == uploadItem.file_name);

      // 画像キャッシュがない場合はロード
      if(selectedImageItem.length == 0){
        await http.get(`/api/teacher/webup_detail/download_image?webup_history_id=${state.webup_history_id}&file_name=${state.selectedUploadItem.file_name}`).then(response => {
          const imageItem = new ImageItem(state.selectedUploadItem.file_name, response.data.base64_image)
          state.imageItems.push(imageItem);
        });
      }

      state.selectedImageItem = state.imageItems.filter(x => x.fileName == uploadItem.file_name)[0];
    };

    /******************************
     * 生徒検索API
     ******************************/

    const searchStudent = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/student_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.students = response.data.students;
        state.totalCount = state.students.length == 0 ? 0 : state.students[0].full_count;
        state.currentPage = 1;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 生徒検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      searchStudent();
    };

    /************************************************************
     * 再チェック
     ************************************************************/

    const reCheck = async () => {

      state.errors = []
      const idx = state.uploadItems.indexOf(state.selectedUploadItem);
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/webup_detail/re_check`, {webup_history_id: state.webup_history_id, upload_items: state.uploadItems}).then(response => {
        state.uploadItems = response.data.read_result_hashes.map((x: any) => new UploadItem(x));
        changeCurrent(state.uploadItems[idx]);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 答案削除
     ************************************************************/

    const destroy = async (file_name: string) => {

      if(!window.confirm("答案用紙を削除します。よろしいですか？")){
        return;
      }

      state.errors = []
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/webup_detail/destroy_upload_item`, {webup_history_id: state.webup_history_id, file_name: file_name}).then(response => {

        alert("処理が完了しました。");
        if(state.uploadItems.length > 1){
          window.location.reload();
        }else{
          window.history.back();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 答案登録実行
     ************************************************************/

    const createJob = async () => {

      if(isExistsError.value){
        alert("エラーの答案が存在するため実行できません。エラーを解消してから実行してください。");
        return;
      }

      if(!window.confirm("答案用紙を登録します。よろしいですか？")){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/webup_detail`, {webup_history_id: state.webup_history_id, upload_items: state.uploadItems}).then(response => {
        alert("登録処理が完了しましたらメールでお知らせします。しばらくお待ちください。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * mounted
     ******************************/

    onMounted(async () => {
      state.webup_history_id = context.root.$route.params.webup_history_id;
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中...しばらくお待ち下さい。");
      await http.get(`/api/teacher/webup_detail?webup_history_id=${state.webup_history_id}`).then(async response => {
        context.root.$store.commit("setSheetType", response.data.sheet_type);
        state.sheetTypeName = Common.getSheetTypeName(response.data.sheet_type);
        // QR読み込み結果を格納
        state.uploadItems = response.data.read_result_hashes.map((x: any) => new UploadItem(x));
        
        // 選択画像を先頭行に設定
        changeCurrent(state.uploadItems[0]);
      })
      .catch(error=>{
        if(error.response && error.response.status == 422){
          alert(`読込結果の取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert("読込結果の取得処理に失敗しました。前の画面に戻ります。");
        }
        window.history.back();
      });

      adjustHeight();
      adjustWidth();
      window.addEventListener("resize", adjustHeight);
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      modalSearchStudent,
      filteredUploadItems,
      errorCount,
      changeCurrent,
      imageStyle,
      imageWrapStyle,
      scaleUp,
      scaleDown,
      adjustWidth,
      prevCurrent,
      nextCurrent,
      rotateLeft,
      rotateRight,
      rotateAll,
      reCheck,
      createJob,
      destroy,
      searchStudent,
      clearCondition,
      changePage,
      getPosName,
      perspectiveTransform,
      resetTransform,
      circleCenter,
      tdStyle,
      dragStop,
    };
  }
});

